// Ocena pomiaru obwodu wg DIN VDE 0100-600 (Erstprüfung) i progów z VDE 0100-410 (14.10.2026). Aplikacja tylko podpowiada:
// ocenę i podpis daje Elektrofachkraft. Każda przekroczona granica ma opis po polsku (ekran) i po niemiecku (protokół).
import { POMIAR_OBWODU } from './katalog.js';

export const U0 = 230; // napięcie fazowe sieci 230/400 V
export const RISO_MIN = 1; // MΩ przy 500 V DC (VDE 0100-600, obwody do 500 V)
export const RCD_T_MAX = 300; // ms przy IΔn (RCD bez zwłoki)
const KROTNOSC = { B: 5, C: 10, D: 20 }; // prąd wyłączenia Ia = k·In (wyłącznik nadprądowy, 0,4 s, TN)

/** „30 mA”, „RCD 30mA”, „FI 0,03 A”, „FI 30” → 30 (mA); null, gdy nie wiadomo (np. samo oznaczenie „RCD-1”). */
export function pradRcd(rcd) {
  const s = String(rcd || '').replace(',', '.');
  const j = s.match(/(\d+(?:\.\d+)?)\s*(mA|A)\b/i); if (j) return /^mA$/i.test(j[2]) ? +j[1] : +j[1] * 1000;
  const g = s.match(/(?:^|[^\d.-])(10|30|100|300|500)(?![\d.])/); return g ? +g[1] : null; // typowe wartości IΔn bez jednostki
}
/** „B16”, „B 16 A”, „LS C10” → { ch: 'B', In: 16 }; null, gdy brak danych. */
export function zabezpieczenie(z) {
  const m = String(z || '').toUpperCase().match(/\b([BCD])\s*(\d+(?:[.,]\d+)?)/); return m ? { ch: m[1], In: +m[2].replace(',', '.') } : null;
}
/** Największa dopuszczalna impedancja pętli Zs = U0 / Ia; null bez danych zabezpieczenia. */
export function zsMax(obwod) { const z = zabezpieczenie(obwod?.zabezpieczenie); return z ? U0 / (KROTNOSC[z.ch] * z.In) : null; }
/** Prąd zwarciowy z pomiaru Zs (A). */
export const ik = (zs) => (zs > 0 ? U0 / zs : null);

const r2 = (x) => String(Math.round(x * 100) / 100).replace('.', ',');

/** wartosci z formularza lub miernika, obwod z budowy → { wynik: 'ok'|'nie_ok'|'niepelny', uwagi: [{ pole, pl, de }], brak } */
export function ocenaPomiaru(wartosci = {}, obwod = {}) {
  const w = wartosci; const uwagi = []; const rcd = !!obwod?.rcd;
  const dodaj = (pole, pl, de) => uwagi.push({ pole, pl, de });
  if (w.ogledziny === 'nie OK') dodaj('ogledziny', 'Oględziny: nie OK', 'Besichtigen: nicht i. O.');
  if (w.proby === 'nie OK') dodaj('proby', 'Próby działania: nie OK', 'Erproben: nicht i. O.');
  if (typeof w.riso === 'number' && w.riso < RISO_MIN) dodaj('riso', `R(iso) ${r2(w.riso)} MΩ poniżej ${RISO_MIN} MΩ`, `R(iso) < ${RISO_MIN} MOhm`);
  if (rcd && typeof w.rcd_t === 'number' && w.rcd_t > RCD_T_MAX) dodaj('rcd_t', `RCD wyłącza po ${r2(w.rcd_t)} ms, dopuszczalne ${RCD_T_MAX} ms`, `t(RCD) > ${RCD_T_MAX} ms`);
  const idn = rcd ? pradRcd(obwod.rcd) : null;
  if (idn && typeof w.rcd_i === 'number' && (w.rcd_i < 0.5 * idn || w.rcd_i > idn))
    dodaj('rcd_i', `RCD zadziałał przy ${r2(w.rcd_i)} mA, powinien między ${r2(idn / 2)} a ${r2(idn)} mA`, `I(RCD) außerhalb 0,5–1,0 × IΔn (${r2(idn)} mA)`);
  const zmax = zsMax(obwod);
  if (zmax && typeof w.zs === 'number' && w.zs > zmax) dodaj('zs', `Zs ${r2(w.zs)} Ω większa niż dopuszczalne ${r2(zmax)} Ω dla ${obwod.zabezpieczenie}`, `Zs > ${r2(zmax)} Ohm (${obwod.zabezpieczenie}, 0,4 s)`);
  const brak = POMIAR_OBWODU.filter((p) => (!p.tylkoRcd || rcd) && w[p.id] === undefined).length;
  return { wynik: uwagi.length ? 'nie_ok' : brak ? 'niepelny' : 'ok', uwagi, brak };
}
